import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://enqqmkzbihekepmwgkxy.supabase.co';
const SUPABASE_ANON_KEY =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVucXFta3piaWhla2VwbXdna3h5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE2OTMyOTMzMjMsImV4cCI6MjAwODg2OTMyM30.eq6c496Ujcsk_SaGYYpIZ-M4MsaoV0IPhCujRLfOWG8';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

export default function DB() {
  let baseName = 'base36';
  let body = 'f';
  let name = 'Fukuro';

  let dataJson = {
    avatar_id: baseName,
    base: baseName,
    body: body,
    name: name,
    thumb: '',
    custom_id_1: 'c4476fd6-c70c-4d81-8e40-6f8753d28fe3',
    //custom_id_2: 'd8ca14c3-5f99-4752-89ee-224728f24f9e',
    json: {
      eye: [{ id: 'e1', onlyPro: false }],
      special: [{ id: 's0', onlyPro: false }],
      hair: [
        { id: 'h1', onlyPro: false },
        { id: 'h2', onlyPro: true },
        { id: 'h3', onlyPro: true },
        { id: 'h4', onlyPro: true },
        { id: 'h5', onlyPro: true },
        { id: 'h6', onlyPro: true },
        { id: 'h7', onlyPro: true },
      ],
      mouth: [{ id: 'm1', onlyPro: false }],
      beard: [{ id: 'b0', onlyPro: false }],
      eyebrow: [
        { id: 'eb1', onlyPro: false },
        { id: 'eb2', onlyPro: true },
        { id: 'eb3', onlyPro: true },
        { id: 'eb4', onlyPro: true },
        { id: 'eb5', onlyPro: true },
      ],
      cloth: [
        { id: 'c1', onlyPro: false },
        { id: 'c2', onlyPro: false },
        { id: 'c3', onlyPro: true },
        { id: 'c4', onlyPro: true },
        { id: 'c5', onlyPro: true },
        { id: 'c6', onlyPro: true },
      ],
      glass: [
        { id: 'g0', onlyPro: false },
        { id: 'g1', onlyPro: true },
        { id: 'g2', onlyPro: true },
        { id: 'g3', onlyPro: true },
        { id: 'g4', onlyPro: true },
        { id: 'g5', onlyPro: true },
      ],
    },
  };

  let dataJson2 = {
    data: [
      {
        bgm_id: 'gourmet1',
        category: 'gourmet',
        duration: '00:30',
        title: 'Coffee Aroma',
        author: null,
        isPro: false,
      },
      {
        bgm_id: 'gourmet2',
        category: 'gourmet',
        duration: '00:30',
        title: 'Spicy Encounter',
        author: null,
        isPro: false,
      },
      {
        bgm_id: 'gourmet3',
        category: 'gourmet',
        duration: '00:30',
        title: 'Wine Serenade',
        author: null,
        isPro: false,
      },
      {
        bgm_id: 'gourmet4',
        category: 'gourmet',
        duration: '00:30',
        title: 'Bakery Bliss',
        author: null,
        isPro: false,
      },
      {
        bgm_id: 'gourmet5',
        category: 'gourmet',
        duration: '00:30',
        title: 'Sushi Harmony',
        author: null,
        isPro: false,
      },
      {
        bgm_id: 'gourmet6',
        category: 'gourmet',
        duration: '00:30',
        title: 'Pasta Rhythms',
        author: null,
        isPro: false,
      },
      {
        bgm_id: 'gourmet7',
        category: 'gourmet',
        duration: '00:30',
        title: 'Grill Nights',
        author: null,
        isPro: false,
      },
      {
        bgm_id: 'gourmet8',
        category: 'gourmet',
        duration: '00:30',
        title: 'Dessert Dreams',
        author: null,
        isPro: false,
      },
      {
        bgm_id: 'gourmet9',
        category: 'gourmet',
        duration: '00:30',
        title: 'Seafood Symphony',
        author: null,
        isPro: false,
      },
      {
        bgm_id: 'gourmet10',
        category: 'gourmet',
        duration: '00:30',
        title: 'Pizza Party',
        author: null,
        isPro: false,
      },
      {
        bgm_id: 'gourmet11',
        category: 'gourmet',
        duration: '00:30',
        title: 'Chocolate Euphoria',
        author: null,
        isPro: false,
      },
      {
        bgm_id: 'gourmet12',
        category: 'gourmet',
        duration: '00:30',
        title: 'Bistro Vibes',
        author: null,
        isPro: false,
      },
      {
        bgm_id: 'gourmet13',
        category: 'gourmet',
        duration: '00:30',
        title: 'Steakhouse Melody',
        author: null,
        isPro: false,
      },
      {
        bgm_id: 'gourmet14',
        category: 'gourmet',
        duration: '00:30',
        title: 'Taco Groove',
        author: null,
        isPro: false,
      },
      {
        bgm_id: 'gourmet15',
        category: 'gourmet',
        duration: '00:30',
        title: 'Brewery Beats',
        author: null,
        isPro: false,
      },
    ],
  };

  useEffect(() => {
    //insertBGM();
    //insertDB();
    //fetchMyData();
  }, []);

  // データを取得する非同期関数
  async function fetchMyData() {
    let { data: users, error } = await supabase.from('avatars').select('*');
    if (error) console.log('データ取得エラー', error);
    else console.log('ユーザーデータ:', users[0].json.base);
  }

  async function insertBGM() {
    dataJson2.data.forEach(async (d) => {
      const { data, error } = await supabase.from('bgm').upsert([d]);

      if (error) {
        console.error('エラー:', error);
      } else {
        console.log('挿入したデータ:', data);
      }
    });
  }

  async function insertDB() {
    const { data, error } = await supabase.from('avatars').upsert([dataJson]);

    if (error) {
      console.error('エラー:', error);
    } else {
      console.log('挿入したデータ:', data);
    }
  }

  return (
    <>
      <div style={{ paddingTop: 100, color: '#fff' }}>hello</div>
    </>
  );
}
